import { useCallback, useEffect, useRef, useState } from "react";
import { shallow } from "zustand/shallow";
import { useHeaderStore } from "../../../../../store/header.store";

import style from "./ReportInquiryFrequencybyProcedure.module.css";
import styleForm from "../../../../../common/theme/styles/form.module.css";
import styleDataTable from "../../../../../common/UI/DataTable/dataTable.module.css";

import ProgressBar from "../../../../../common/UI/ProgressBar";
import useFormattedDate from "../../../../../common/hooks/useFormattedDate";

import ChartComponent from "../../../components/chart";
import InputSearch from "../../../../../common/UI/DataTable/inputSearch";
import { GetReportInquiryFrequencybyProcedureService } from "../../../services/Reports/getReportInquiryFrequencybyProcedure.service";
import { format, subDays } from "date-fns";
import { GetAnalyticsFiltersService } from "../../../../../common/services/getAnalyticsFilters.service";
import DataTable from "../../../../../common/UI/DataTable/dataTable";
import { GetSessionsWithPaginationService } from "../../../services/Reports/getSessionsWithPagination.service";
import AppInputSearchFilter from "../../../../../common/UI/Inputs/appInputSearchFilter";
import AppButton from "../../../../../common/UI/Buttons/AppButton"
import { GetInquiryDetailsBySessionService } from "../../../services/dashboard/getInquiryDetailsBySession.service"
import Modal from "../../../../../common/UI/Modal"
import { ConversationViewer } from "../../../components/ConversationViewer"
import { DataSelectDto } from "../../../../../common/dtos/general.dto";
import { GetWidgetsFilterWithPaginationService } from "../../../services/getWidgetsFilterWithPagination.service";

const getSessionsWithPaginationService = new GetSessionsWithPaginationService();


interface ProcedureFrequencyItem {
  process: string;
  value: number;
}

interface ConversationMessage {
  inquiryId: string
  inquiryDate: string
  citizenId: string | null
  procedureTypeId: string | null
  question: string
  userInquiry: string
  inquiryForever: string
  inquiryDateTime: string
  inquiryGetDay: string
  inquiryStart: string
  inquiryGetMinute: string
  responseGeneratedDate: string
  responseGenerated: string
  userFeedback: string | null
}


export default function ReportInquiryFrequencybyProcedurePage() {
  const headerStore = useHeaderStore(
    (state) => ({
      setModule: state.setModule,
      setModuleItem: state.setModuleItem,
    }),
    shallow
  );
  const hFormatDate = useFormattedDate();
  const today = new Date();

  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false);
  const [startDateInquiryFrequencybyProcedure, setStartDateInquiryFrequencybyProcedure] = useState<Date>(subDays(today, 7));
  const [endDateInquiryFrequencybyProcedure, setEndDateInquiryFrequencybyProcedure] = useState<Date>(today);
  const [widgetFilter, setWidgetFilter] = useState<DataSelectDto>({
    label: '',
    value: ''
  });

  const [responseDataGraphInquiryFrequencybyProcedure, setResponseDataGraphInquiryFrequencybyProcedure] = useState<any | null>(null);

  const [dataGraphSessionInquiryFrequencybyProcedure, setDataGraphInquiryFrequencybyProcedure] = useState<any[]>([]);
  const [dataGraphoptionsInquiryFrequencybyProcedure, setDataGraphoptionsInquiryFrequencybyProcedure] = useState<any>({});
  const [dataChannels, setDataChannels] = useState<any[]>([]);
  const [selectChannels, setSelectChannels] = useState<{ label: string; value: number }[]>([]);


  const [isReloadData, setIsReloadData] = useState(false);

  // Estados para el modal de conversación
  const [conversationMessages, setConversationMessages] = useState<ConversationMessage[]>([])
  const [loadingConversation, setLoadingConversation] = useState(false)

  const latestRequestIdRef = useRef(0);

  const getDataInquiryFrequencybyProcedure = useCallback(async (startDate: Date, endDate: Date) => {
    setLoading(true);

    const currentRequestId = ++latestRequestIdRef.current; // Incrementa ID

    const params: any = {
      startDate: hFormatDate(startDate, "yyyy-MM-dd"),
      endDate: hFormatDate(endDate, "yyyy-MM-dd"),
      channelIds: selectChannels.map((c: any) => c.value),
      widgetId: widgetFilter ? widgetFilter.value : "",
    };
    setIsReloadData(prev => !prev);

    try {
      const response = await GetReportInquiryFrequencybyProcedureService(params);

      if (latestRequestIdRef.current === currentRequestId) {
        if (response) {
          const top10 = Array.isArray(response) ? response.slice(0, 10) : response;
          setResponseDataGraphInquiryFrequencybyProcedure(top10 as ProcedureFrequencyItem);
        } else {
          console.warn("No data received for session analytics.");
          setResponseDataGraphInquiryFrequencybyProcedure(null);
        }
      }

    } catch (error) {
      if (latestRequestIdRef.current === currentRequestId) {
        console.error("Error fetching inquiry averages analytics:", error);
        setResponseDataGraphInquiryFrequencybyProcedure(null);
      }
    } finally {
      if (latestRequestIdRef.current === currentRequestId) {
        setLoading(false);
      }
    }
  }, [selectChannels, hFormatDate,widgetFilter]);
  const serviceAllWidgets = useCallback(async (value: string) => {
    const response: any = await GetWidgetsFilterWithPaginationService({
      search: value,
      perPage: 100
    });
    return response.data.map((item: any) => ({
      label: item.name,
      value: item.widgetId,
    }));
  }, []);




  const getAllAnalyticsFiltersChannels = async () => {
    const response: any = await GetAnalyticsFiltersService();
    setDataChannels(
      response.channels.map((item: any) => {
        return {
          label: item.channelName,
          value: item.channelId
        };
      })
    );
  };



  useEffect(() => {
    if (startDateInquiryFrequencybyProcedure && endDateInquiryFrequencybyProcedure) {
      getDataInquiryFrequencybyProcedure(startDateInquiryFrequencybyProcedure, endDateInquiryFrequencybyProcedure);
    }
  }, [startDateInquiryFrequencybyProcedure, endDateInquiryFrequencybyProcedure, selectChannels, widgetFilter]);



  useEffect(() => {
    headerStore.setModule("Reportes", "");
    headerStore.setModuleItem("Frecuencia consulta", "/admin/home");
    getAllAnalyticsFiltersChannels();


  }, []);

  // Helper para leer la var CSS
  const readOnSurface = () =>
    getComputedStyle(document.documentElement)
      .getPropertyValue('--color-on-surface-variant-main')
      .trim() || '#22356a';

  const [onSurface, setOnSurface] = useState(readOnSurface());

  useEffect(() => {
    const el = document.documentElement;
    const update = () => {
      const next = readOnSurface();
      setOnSurface(prev => (prev !== next ? next : prev));
    };
    const obs = new MutationObserver(update);
    // Detecta cambios en clase/tema/estilos del <html> (incluye cambios de CSS vars)
    obs.observe(el, { attributes: true, attributeFilter: ['class', 'data-theme', 'style'] });
    update(); // primer chequeo
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (!responseDataGraphInquiryFrequencybyProcedure) return;

    // DATA: [{ process: string, value: number }, ...]
    const rows = responseDataGraphInquiryFrequencybyProcedure as ProcedureFrequencyItem[];

    const categories = rows.map(r => r.process);
    const data = rows.map(r => Number(r.value) || 0);

    setDataGraphInquiryFrequencybyProcedure([{ name: 'Frecuencia %', data }]);

    setDataGraphoptionsInquiryFrequencybyProcedure({
      chart: {
        type: 'bar',
        height: 420,
        foreColor: onSurface, // <-- color global de textos
        toolbar: {
          show: true,
          tools: { download: true, selection: true, zoom: true, zoomin: true, zoomout: true, pan: true, reset: true },
          autoSelected: 'zoom',
        },
      },
      theme: { palette: 'palette8' },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: { position: 'right' },
          borderRadius: 4,
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val: number) => `${val}%`,
        style: { fontSize: '10px', colors: [onSurface] }, // <-- color de las etiquetas
      },
      xaxis: {
        categories,
        title: { text: 'Porcentaje', style: { fontSize: '12px', color: onSurface } }, // <-- title usa "color"
        labels: { style: { fontSize: '11px', colors: onSurface } },                   // <-- labels usan "colors"
      },
      yaxis: {
        title: { text: 'Trámite', style: { fontSize: '12px', color: onSurface } },
        labels: { style: { fontSize: '11px', colors: onSurface } },
      },
      tooltip: {
        y: { formatter: (val: number) => `${val}%` },
        style: { fontSize: '12px', fontFamily: 'inherit' },
      },
      legend: { show: false, labels: { colors: onSurface } },
      grid: { borderColor: onSurface.startsWith('#') ? `${onSurface}22` : undefined },
    });
  }, [responseDataGraphInquiryFrequencybyProcedure, onSurface]);



  const columns = [
    {
      header: "ID SESIÓN",
      field: "sessionId",
      render: (row: any) => {
        return (
          <div style={{ width: '200px' }}
          >{row.sessionId}</div>
        )
      }
    },
    {
      header: "FECHA INICIO",
      field: "",
      render: (row: any) => {
        return <>{row.startDate ? <div>{hFormatDate(row.startDate, "dd-MM-yyyy hh:mm:ss a")}</div> : ""}</>
      },
    },
    {
      header: "ESTADO",
      field: "status",
    },
    {
      header: "WIDGET ID",
      field: "widgetId",
    },
    {
      header: "CÓDIGO CIUDADANO",
      field: "",
      render: (row: any) => {
        return (
          <>
            {row.citizen ? (
              <div>{row.citizen.externalChannelId}</div>
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      header: "CANAL",
      field: "",
      render: (row: any) => {
        return (
          <>
            {row.citizen ? (
              <div>{row.citizen.communicationChannel?.channelName}</div>
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      header: "OPCIONES",
      field: "",
      render: (row: any) => (
        <AppButton
          className={styleDataTable.buttom_option}
          variant="primary"
          iconName="edit"
          buttonText="Ver Conversación"
          onClick={() => handleView(row)}
        />
      ),
    },
  ]


  const handleView = async (row: any) => {
    // Validate that row has the required data
    if (!row || !row.sessionId) {
      console.error("Invalid session data:", row)
      return
    }

    setIsOpen(true)
    setLoadingConversation(true)
    setConversationMessages([])

    try {
      const params = {
        sessionId: row.sessionId,
      }

      const response: any = await GetInquiryDetailsBySessionService(params)

      // Handle the specific response structure from the API
      setConversationMessages(response)

    } catch (error) {
      console.error("Error fetching conversation details:", error)
      setConversationMessages([])
    } finally {
      setLoadingConversation(false)
    }
  }




  const handleCloseModal = () => {
    setIsOpen(false)
    setConversationMessages([])
    setLoadingConversation(false)
  }

  return (
    <div className={style.Dashboard_page}>
      <h4 className={style.under__line}>
        <strong>Frecuencia consulta por trámite</strong>
      </h4>

      {/* Muestra el componente Loading siempre */}
      {loading && <ProgressBar />}
      <div className={style.containerGraph} style={{ marginTop: "0.5rem" }}>
        <div className={style.containerFilters}>
          <div >
            <AppInputSearchFilter
              name="channels"
              textLabel="Selecciona canal"
              data={dataChannels}
              selected={selectChannels}
              onSelect={setSelectChannels}
              multiple={true}

            />
            
          </div>
          <div
            className={style.container__select}
            style={{ minWidth: "280px" }}
          >
            <InputSearch
              key={crypto.randomUUID()}
              name="status"
              classNameInput={styleForm.input__input}
              textLabel="Selecciona widget"
              serviceCall={serviceAllWidgets}
              onSelect={(selected) => {
                setWidgetFilter(selected);
              }}
              selected={widgetFilter}
            />
          </div>
        </div>

        <ChartComponent
          key={`inquiry-by-procedure-${onSurface}`} // <-- remonta al cambiar el color
          titleChart="Consultas por trámite"
          typeGraph="bar"
          selectableTypes={["bar"]}
          dataDashboard={dataGraphSessionInquiryFrequencybyProcedure}
          dataOptions={dataGraphoptionsInquiryFrequencybyProcedure}
          onDateChange={(dateRange) => {
            if (dateRange) {
              setStartDateInquiryFrequencybyProcedure(dateRange[0]);
              setEndDateInquiryFrequencybyProcedure(dateRange[1]);
            }
          }}
        />
        <DataTable
          title="Listado de sesiones"
          columns={columns}
          service={getSessionsWithPaginationService}
          reloadData={isReloadData}
          // addButton={addButton}
          showSearch={false}
          params={{
            startDate: hFormatDate(startDateInquiryFrequencybyProcedure, "yyyy-MM-dd"),
            endDate: hFormatDate(endDateInquiryFrequencybyProcedure, "yyyy-MM-dd"),
            channelIds: selectChannels.map((c: any) => c.value),
            widgetId: widgetFilter ? widgetFilter.value : "",
          }}
          excelButton={{
            enabled: true,
            nameFile: `Lista de Sesiones`,
            getExcelData: (data) => {
              return data.map((row: any) => ({
                ID_SESIÓN: row.sessionId ?? "",
                FECHA_INICIO: row.startDate
                  ? hFormatDate(row.startDate, "dd-MM-yyyy hh:mm:ss a") // o new Date(row.startDate) si quieres celda de fecha real
                  : "",
                ESTADO: row.status ?? "",
                WIDGET_ID: row.widgetId ?? "",
                CÓDIGO_CIUDADANO: row.citizen?.externalChannelId ?? "",
                CANAL: row.citizen?.communicationChannel?.channelName ?? "",
              }));
            },
          }}

        >
          {''}
        </DataTable>
        <Modal
          title="Detalle de Conversación"
          isOpen={isOpen}
          onClose={handleCloseModal}
          size={{ width: "90%", maxWidth: "1400px", height: "80vh" }}
          loadingModal={false}
          footerContent={
            <div className={style.containerButtoms}>
              <button className={styleForm.buttomFooter + " " + styleForm.buttom_cancelar} onClick={handleCloseModal}>
                Cerrar
              </button>
            </div>
          }
        >
          {/* {selectedSessionData && ( */}
          <ConversationViewer
            messages={conversationMessages}
            loading={loadingConversation}
          />
          {/* )} */}
        </Modal>
      </div>

    </div>
  );

}
